<template>
  <footer class="footer">
    <div class="footer-content">
      <ButtonThe3DButton @click="emits('join')" v-if="isEntrance" class="join-button" size="lg" color="red">
        {{$t('niuniu.quickJoin')}}
      </ButtonThe3DButton>
      <slot name="area"></slot>
      <!-- <div class="footer-icons">
        <IconSvgUse 
          v-for="icon in icons" 
          :key="icon" 
          :use="icon" 
          class="footer-icon" 
        />
        
        <div class="rtp-info">
          <span class="rtp-label">RTP</span>
          <span class="rtp-value">{{ rtp }}</span>
          <IconSvgUse use="icon-question" class="footer-icon" />
        </div>
        
        <IconSvgUse use="icon-hearth-empty" class="footer-icon" />
      </div>
      
      <div class="promo-banner">
        <img class="promo-icon" src="../img/trophy.png" alt="Promotion" />
        <div class="promo-info">
          <div class="promo-title">Free-to-play BETCORGI 竞赛:</div>
          <div class="promo-time">06:06:17</div>
        </div>
        <div class="promo-amount">
          <span>$150</span>
          <IconSvgUse use="icon-arrow-right-small" class="arrow-icon" />
        </div>
      </div> -->
    </div>
  </footer>
</template>

<script setup lang="ts">
const $i18n = useNuxtApp().$i18n;

defineProps<{
  rtp: string,
  isEntrance:Boolean
}>()

const emits = defineEmits(['join'])
const icons = [
  'icon-statistic',
  'icon-fairness',
  'icon-rules',
  'icon-settings-new'
] as const
</script>

<style scoped lang="scss">
.footer {
  flex: 0 0 auto;
  width: 100%;
  // padding: 16px 0px;
  padding-bottom:10px;
  // box-shadow: 0px -15px 30px 0px #00000040;

  .footer-content {
     width: 100%;
  padding: 0 1rem;
  background: var(--background-primary);
  
  /* 安全区域适配 */
  padding-bottom: env(safe-area-inset-bottom);
  margin-bottom: calc(-1 * env(safe-area-inset-bottom));
    padding-bottom: env(safe-area-inset-bottom);
  }

  .join-button {
    width: 100%;
  }

  .footer-icons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 0.75rem;

    .footer-icon {
      width: 1.5rem;
      height: 1.5rem;
      color: var(--color_grey-40);
      transition: all 0.1s;
    }

    .rtp-info {
      display: flex;
      align-items: center;
      gap: 0.375rem;
      padding-right: 0.625rem;
      border-right: 0.063rem solid var(--Background-Quaternary);
      font-size: 0.875rem;
      font-weight: 800;
      line-height: 1.125rem;

      .rtp-label {
        color: white;
      }

      .rtp-value {
        background: linear-gradient(90deg, #FFB636 0%, #FF5C00 113.21%);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
      }
    }
  }

  .promo-banner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #19212C;
    padding: 1rem 1rem 0.5rem;
    border-radius: 0.625rem 0.625rem 0 0;

    .promo-icon {
      width: 2.25rem;
      height: 2.25rem;
    }

    .promo-info {
      flex: 1;
      padding-left: 0.375rem;

      .promo-title {
        font-size: 0.75rem;
        color: white;
        font-weight: 600;
        line-height: 1.125rem;
        letter-spacing: 0.031rem;
        max-width: 9.125rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .promo-time {
        font-size: 0.75rem;
        color: rgba(255, 255, 255, 0.64);
        font-weight: 600;
        line-height: 1rem;
        letter-spacing: 0.031rem;
      }
    }

    .promo-amount {
      display: flex;
      align-items: center;
      gap: 0.25rem;

      span {
        font-size: 1.125rem;
        font-weight: 800;
        line-height: 1.5rem;
        background: linear-gradient(90deg, #FFB636 0%, #FF5C00 113.21%);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
      }

      .arrow-icon {
        width: 1.5rem;
        height: 1.5rem;
        color: var(--color_grey-20);
      }
    }
  }
}
</style>